import {Repository} from '@s-ui/domain'

/**
 * @interface
 */
export class VehiclesRepository extends Repository {
  /**
   * @method
   * @return {Error}
   */
  getBrandModelInfo({makeId, modelId}) {
    throw new Error('[VehicleRepository#getBrandModelInfo] must be implemented')
  }

  getCompetitors({vehicleId}) {
    throw new Error('[VehicleRepository#getCompetitors] must be implemented')
  }

  getInfoVehicle({field, params}) {
    throw new Error('[VehicleRepository#getInfoVehicle] must be implemented')
  }

  getMarketedMakes() {
    throw new Error('[VehicleRepository#getMarketedMakes] must be implemented')
  }

  getModelsGroupedByBodyTypeDoors() {
    throw new Error('[VehicleRepository#getModelsGroupedByBodyTypeDoors] must be implemented')
  }

  getModelInfo() {
    throw new Error('[VehicleRepository#getModelInfo] must be implemented')
  }

  getBodyTypeInfo() {
    throw new Error('[VehicleRepository#getBodyTypeInfo] must be implemented')
  }

  getVersionInfo() {
    throw new Error('[VehicleRepository#getVersionInfo] must be implemented')
  }

  getVehicleInfo() {
    throw new Error('[VehicleRepository#getVehicleInfo] must be implemented')
  }

  getSearchModels({makeId}) {
    throw new Error('[VehicleRepository#getSearchModels] must be implemented')
  }

  getModelImageByMakeModel({getModelImageRequestValueObject}) {
    throw new Error('[VehicleRepository#getModelImageByMakeModel] must be implemented')
  }

  getVehicleImages({getImagesVehiclesRequest}) {
    throw new Error('[VehicleRepository#getVehicleImages] must be implemented')
  }

  getModelImages({getImagesVehiclesRequest}) {
    throw new Error('[VehicleRepository#getModelImages] must be implemented')
  }

  getVehicleImage({getImagesVehiclesRequest}) {
    throw new Error('[VehicleRepository#getVehicleImage] must be implemented')
  }

  getModelImage({getImagesVehiclesRequest}) {
    throw new Error('[VehicleRepository#getModelImage] must be implemented')
  }
}
